import { useEffect, useState } from 'react';
import { ArrowUpRight, X } from 'lucide-react';
import { Wordmark } from './Wordmark';

const links = [
  { href: '#work', label: 'Work' },
  { href: '#services', label: 'Services' },
  { href: '#process', label: 'Process' },
];

export function SiteHeader() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, []);

  useEffect(() => {
    if (!open) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = previousOverflow; };
  }, [open]);

  return (
    <header className="site-header">
      <a className="wordmark" href="#top" aria-label="Workcrafted home"><Wordmark /></a>
      <nav className="desktop-nav" aria-label="Primary navigation">
        {links.map((link) => <a key={link.href} href={link.href}>{link.label}</a>)}
      </nav>
      <a className="header-cta" href="#contact">
        <span>Start a project</span>
        <ArrowUpRight aria-hidden="true" size={18} />
      </a>
      <button
        className="mobile-menu-button"
        type="button"
        aria-expanded={open}
        aria-controls="mobile-navigation"
        onClick={() => setOpen((value) => !value)}
      >
        {open ? <><span>Close</span><X aria-hidden="true" size={20} /></> : <span>Menu</span>}
      </button>
      <div className={`mobile-nav ${open ? 'is-open' : ''}`} id="mobile-navigation" aria-hidden={!open}>
        <nav aria-label="Mobile navigation">
          {links.map((link) => (
            <a key={link.href} href={link.href} onClick={() => setOpen(false)}>{link.label}</a>
          ))}
          <a className="mobile-nav__cta" href="#contact" onClick={() => setOpen(false)}>
            <span>Start a project</span><ArrowUpRight aria-hidden="true" size={20} />
          </a>
        </nav>
      </div>
    </header>
  );
}
